

interface solutionItem {
    type: string;
    url: string;
    aufgabeId: number;
    name: string;
}

export function displaySolutionTips(solutionText:string, solutionItems:Array<{number:solutionItem}>){
    
    let html = '';
    if ((solutionText != '' && solutionText !== null) || solutionItems.length > 0){ // passt length hier überhaupt, ist das ein Array?
        html += '<hr>' +
        '<div class="loesungsweg text-end">' + 
        '<button type="button" class="btn btn-light-info text-info font-weight-medium waves-effect open-losung btn-lg">Lösungshinweise anzeigen</button>' +
        '<div class="final-losung form-group d-none my-3">';
        if ((solutionText != '' && solutionText !== null)){
            html += '<div disabled class="form-control mb-2" style="height: 100%; text-align: start;">' + solutionText + '</div>'
        }
        if (solutionItems.length > 0){
            html += displaySolutionItems(solutionItems);
        }
        '</div>'
    }
    return html;
}

function displaySolutionItems(solutionItems:Array<{number: solutionItem}>):string{
    let html = '';
    for (const[ind, item] of Object.entries(solutionItems)){
        html += '<div class="mt-2">' + displaySolutionItem(item) + '</div>'
    }
    return html;
}

function displaySolutionItem(item:solutionItem):string{
    let color = 'info';
    let icon = 'mdi-image';
    
    if (['png', 'jpg', 'jpeg'].includes(item.type.toLowerCase())){
        icon = 'mdi-image'
    } else if (item.type == 'pdf'){
        icon = 'mdi-file-pdf';
        color = 'danger'
    } else if (item.type == 'yt'){

    } else {
        icon = 'mdi-book-open'
    }

    return '<a href="' + item.url + '" class="btn btn-light-' + color + ' text-' + color + ' font-weight-medium" target="_blank"><i class="mdi ' + icon + '"></i> ' + item.name + '</a>';
}